<template>
    <div class="card">
        <div v-if="$can('view','water_meter')" class="row">
            <Toast />
            <DataTable :value="all_water_meters" :paginator="true" :rows="10"
            :paginatorTemplate="paginatorTemplate"
            :rowsPerPageOptions="[10,20,50]" 
            currentPageReportTemplate="{first} to {last} of {totalRecords}"
            stripedRows :loading="loading" removableSort
            :globalFilterFields="['name']"
            v-model:filters="filters"  >
                <template #header>
                    <div class="table-header flex flex-column md:flex-row md:justify-content-end">
                        <span class="p-input-icon-left ">
                            <i class="pi pi-search" />
                            <InputText id="filter_water_meters" v-model="filters['global'].value" placeholder="Keyword Search" class="input_small"/>
                        </span>
                    </div>
                </template>
                <Column header="Name" field="name" :sortable="true"/>
                <Column header="Terminal" field="id_terminal.name" :sortable="true"/>
                <Column v-if="$can('change','water_meter')" header="Edit" style="width: 7rem;">
                    <template #body="slotProps">
                        <Button data-cy="edit_button" icon="pi pi-pencil" class="p-button-rounded p-button-info p-button-outlined" @click="edit_water_meter(slotProps.data)"/>
                    </template>
                </Column>
                <Column v-if="$can('delete','water_meter')" header="Delete" style="width: 7rem;">
                    <template #body="slotProps">
                        <Button data-cy="delete_button" icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-outlined" @click="confirm_delete_water_meter(slotProps)"/>
                    </template>
                </Column>
            </DataTable>
        </div>
    </div>

    <Dialog data-cy="edit_water_meter_modal" v-model:visible="water_meter_dialog" :breakpoints="{'960px': '90vw'}" :style="{width: '50vw'}" header="Terminal Details" :modal="true" class="p-fluid">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-10 md:col-12">
                    <div class="p-float-field">
                        <label for="name" class="ps-1 pb-1"> <strong>Name</strong> </label>
                        <InputText id="name" v-model.trim="water_meter.name" required="true" autofocus :class="{'p-invalid': submitted && !water_meter.name || water_meter_errors.name}" />
                        <small class="p-error" v-if="submitted && !water_meter.name">Name is required.</small>
                        <small v-if="Object.keys(water_meter_errors).length !== 0 && water_meter_errors.name" class="p-error"><span v-for="error in water_meter_errors.name" :key="error">{{error}}<br></span></small>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-10 md:col-12">
                    <div class="p-float-field">
                        <label for="name" class="ps-1 pb-1"> <strong> Terminal </strong> </label>
                        <Dropdown id="id_finger" v-model="water_meter.id_terminal" :options="all_terminals" optionLabel="name" :filter="true"> 
                            <template #value="slotProps">
                                <div v-if="slotProps.value && slotProps.value.name">
                                    <span>{{slotProps.value.name}}</span>
                                </div>
                                <div v-else-if="slotProps.label && !slotProps.value.value">
                                    <span>{{slotProps.name}}</span>
                                </div>
                            </template>
                        </Dropdown>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Cancel" class="p-button-text" @click="hide_water_meter_dialog"/>
            <Button data-cy="save_edit_water_meter" label="Save" @click="save_water_meter" />
        </template>
    </Dialog>

    <Dialog v-model:visible="delete_water_meter_dialog" :style="{width: '450px'}" header="Confirm" :modal="true">
        <div class="confirmation-content">
            <span v-if="water_meter">Are you sure you want to delete <b>{{water_meter.name}}</b>?</span>
        </div>
        <template #footer>
            <Button label="No" class="p-button-text" @click="delete_water_meter_dialog = false"/>
            <Button data-cy="confirm_delete_button" label="Yes" @click="deleteTerminal" />
        </template>
    </Dialog>

</template>

<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Toast from 'primevue/toast'
import Dialog from 'primevue/dialog'
import Dropdown from 'primevue/dropdown'

import { FilterMatchMode } from 'primevue/api'
import { required } from '@vuelidate/validators'
import { useVuelidate } from "@vuelidate/core"

export default {
    setup: () => ({ v$: useVuelidate() }),
    name: 'TableTerminals',
    components: {
        DataTable,
        Column,
        Button,
        InputText,
        Toast,
        Dialog,
        Dropdown
    },
    data() {
        return {
            water_meter: {},
            water_meter_errors:{},
            water_meter_dialog: false,
            delete_water_meter_dialog: false,
            submitted: false,
            filters: {
                'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
            },
            loading: false,
            paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        }
    },
    async mounted() {
        window.addEventListener('resize', this.handleResize)
        this.handleResize()
        this.loading = true
        await this.$store.dispatch('load_all_water_meters')
        await this.$store.dispatch('load_all_terminals')
        this.loading = false
    },

    async unmounted(){
        window.removeEventListener('resize', this.handleResize);
    },

    computed: {
        all_terminals: function() {
            return this.$store.getters.all_terminals
        },
        all_water_meters: function() {
            return this.$store.getters.all_water_meters
        },
        get_errors_water_meter: function(){
            return this.$store.getters.get_errors_water_meter
        },
        get_delete_water_meter_status: function() {
            return this.$store.getters.get_delete_water_meter_status
        }
    },
    methods: {

        async handleResize(){
            if (window.innerWidth <= 767){
                this.paginatorTemplate = "CurrentPageReport PrevPageLink NextPageLink"
            } else {
                this.paginatorTemplate = "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            }
        },

        confirm_delete_water_meter(water_meter) {
            this.water_meter = water_meter.data;
            this.delete_water_meter_dialog = true;
        },
        async deleteTerminal() {
            await this.$store.dispatch('delete_water_meter', this.water_meter.id)
            if (!this.get_delete_water_meter_status){
                this.$toast.removeAllGroups();
                this.$toast.add({severity:'success', summary: 'Successful', detail: 'Terminal deleted', life: 3000});    
            }else{
                this.$toast.removeAllGroups();
                this.$toast.add({severity:'error', summary: 'Error', detail: "Terminal can't be deleted", life: 3000});
            }
            this.delete_water_meter_dialog = false;
        },
        edit_water_meter(water_meter) {
            this.water_meter = {...water_meter};
            this.water_meter_dialog = true;
        },
        async save_water_meter() {
            this.submitted = true;
			if (this.water_meter.name.trim()) {
                await this.$store.dispatch('update_water_meter', this.water_meter)
                this.water_meter_errors = this.get_errors_water_meter
                
                if(Object.keys(this.water_meter_errors).length === 0){
                    this.hide_water_meter_dialog();
                    this.water_meter = {};
                    this.$toast.removeAllGroups();
                    this.$toast.add({severity:'success', summary: 'Successful', detail: 'Terminal modified', life: 3000});
                }
            }
        },
        hide_water_meter_dialog() {
            this.water_meter_dialog = false;
            this.submitted = false;
        },
    },
    validations() {
        return {
            name: { required }
        }
    },
}
</script>

<style scoped>
.card {
    box-shadow: 0 2px 1px -1px rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 1px 3px 0 rgba(0,0,0,.12);
    border-radius: 10px;
    margin-bottom: 1rem;
}

.table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media screen and (max-width: 960px) {
        align-items: start;
	}
}

:deep(.p-inputtext){
    font-size: 1rem;
    margin: auto;
}

.input_small{
    font-size: .8rem !important; 
}

</style>